import { useMemo } from 'react';
import { claimValues } from '@functions/allowed-routes';
import { authStorage } from '@functions/auth-session';

/// Nomes do enum EProfileAction do servidor, como chegam na claim "Actions".
export const PROFILE_ACTION = {
    assignLeads: 'AssignLeads',
    closeLeads: 'CloseLeads',
    manageBoards: 'ManageBoards',
    exportLeads: 'ExportLeads',
} as const;

export interface ProfilePermissions {
    canAssignLeads: boolean;
    canCloseLeads: boolean;
    canManageBoards: boolean;
    canExportLeads: boolean;
    userId: string | null;
}

/// Só esconde o botão: quem decide é o servidor, que recusa a ação sem a permissão.
export const useProfilePermissions = (): ProfilePermissions =>
    useMemo(() => {
        const actions = claimValues('Actions');

        return {
            canAssignLeads: actions.has(PROFILE_ACTION.assignLeads),
            canCloseLeads: actions.has(PROFILE_ACTION.closeLeads),
            canManageBoards: actions.has(PROFILE_ACTION.manageBoards),
            canExportLeads: actions.has(PROFILE_ACTION.exportLeads),
            userId: authStorage.read()?.userId ?? null,
        };
    }, []);
